import React from "react";

export default function Compass() {
  return (
    <div
      className="fixed top-20 right-4 md:right-10 z-20 pointer-events-none select-none"
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 60 60"
        width={52}
        height={52}
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="30"
          cy="30"
          r="28"
          fill="rgba(10,14,26,0.7)"
          stroke="rgba(0,212,255,0.2)"
          strokeWidth="1"
        />
        {/* Cardinal marks */}
        {[0, 90, 180, 270].map((deg) => (
          <line
            key={deg}
            x1="30"
            y1="5"
            x2="30"
            y2="10"
            stroke="rgba(0,212,255,0.35)"
            strokeWidth="1"
            transform={`rotate(${deg} 30 30)`}
          />
        ))}
        {/* North arrow */}
        <path d="M30,8 l2.5,8 l-2.5,-3 l-2.5,3 Z" fill="#00d4ff" />
        {/* South arrow */}
        <path d="M30,52 l2.5,-8 l-2.5,3 l-2.5,-3 Z" fill="rgba(148,163,184,0.4)" />
        {/* Center dot */}
        <circle cx="30" cy="30" r="2" fill="rgba(0,212,255,0.5)" />
        {/* N label */}
        <text
          x="30"
          y="22"
          textAnchor="middle"
          dominantBaseline="central"
          fill="rgba(0,212,255,0.9)"
          fontSize="7"
          fontWeight="bold"
          fontFamily="monospace"
        >
          N
        </text>
      </svg>
    </div>
  );
}
